import enCommon from "./locales/en/en.common.json";
import enButtons from "./locales/en/en.buttons.json";
import enHome from "./locales/en/en.homepage.json";
import enLiveDemo from "./locales/en/en.livedemo.json";
import enTaHome from "./locales/en/en.techali-home.json";
import fr from "./locales/fr/fr.json";
export default defineI18nConfig(() => ({
  legacy: false,
  locales: ["en", "fr"],
  defaultLocale: "en",
  messages: {
    en: { ...enCommon, ...enButtons, ...enHome, ...enLiveDemo, ...enTaHome },
    fr: fr,
  },
}));
